<!-- <p>company works!</p> -->
<div class="main-outer company-list">
    <app-header></app-header>
    <div class="municipality-accounts" [ngClass]="Menustatus ? 'show' : ''">
        <!-- <div class="common-add-button" (click) = "onAddIconClick(0)" (click)="onAddIconClick(0)">
            <a href="javascript:void(0);" class="plus-icon"><i
                class="ic plus-ic"></i></a>
        </div> -->

        <div class="municipality-accounts__sidebar doc-cabinet-menu-left">
            <h2 class="heading-secondery">Admin</h2>

            <ul class="dc-menu-list">
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/company" routerLinkActive="active">Customers</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/subscriptions"
                        routerLinkActive="active">Subscriptions</a>
                </li>
                <li class="dc-menu-item">
                    <a href="javascript:void(0);" routerLink="/batches" routerLinkActive="active">Batches</a>
                </li>
            </ul>

            <a href="javascript:void(0);" class="sidebar-menu" (click)="showMenu()">
                <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 1.40476C0 1.07008 0.132951 0.749111 0.369604 0.512457C0.606258 0.275804 0.927229 0.142853 1.26191 0.142853H16.4048C16.7395 0.142853 17.0605 0.275804 17.2971 0.512457C17.5338 0.749111 17.6667 1.07008 17.6667 1.40476C17.6667 1.73944 17.5338 2.06041 17.2971 2.29706C17.0605 2.53372 16.7395 2.66667 16.4048 2.66667H1.26191C0.927229 2.66667 0.606258 2.53372 0.369604 2.29706C0.132951 2.06041 0 1.73944 0 1.40476Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M7.57144 7.7143C7.57144 7.37962 7.70439 7.05865 7.94105 6.822C8.1777 6.58534 8.49867 6.45239 8.83335 6.45239H16.4048C16.7395 6.45239 17.0604 6.58534 17.2971 6.822C17.5338 7.05865 17.6667 7.37962 17.6667 7.7143C17.6667 8.04898 17.5338 8.36995 17.2971 8.6066C17.0604 8.84326 16.7395 8.97621 16.4048 8.97621H8.83335C8.49867 8.97621 8.1777 8.84326 7.94105 8.6066C7.70439 8.36995 7.57144 8.04898 7.57144 7.7143Z"
                        fill="white" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M0 14.0238C0 13.6892 0.132951 13.3682 0.369604 13.1315C0.606258 12.8949 0.927229 12.7619 1.26191 12.7619H16.4048C16.7395 12.7619 17.0605 12.8949 17.2971 13.1315C17.5338 13.3682 17.6667 13.6892 17.6667 14.0238C17.6667 14.3585 17.5338 14.6795 17.2971 14.9161C17.0605 15.1528 16.7395 15.2857 16.4048 15.2857H1.26191C0.927229 15.2857 0.606258 15.1528 0.369604 14.9161C0.132951 14.6795 0 14.3585 0 14.0238Z"
                        fill="white" />
                </svg>
            </a>
        </div>


        <div class="container">
            <div class="alert" [ngClass]="messageClass ? 'success' : 'warning'" *ngIf="displayMessage">
                <p>{{message}}</p>
                <a class="close-popup" href="javascript:void(0);" (click)="closeMessagePopup()">
                    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                        <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E" stroke-width="2" />
                    </svg>
                </a>
            </div>
            <div class="page-wrapper" [ngClass]="filterResposniveEvent ? 'active-sidebar' : ''">
                
                <div class="page-filter" *ngIf="!isCustomerAdmin">
                    <div class="page-filter-inner">
                        <div class="">
                            <a class="close-popup close-popup-filter" href="javascript:void(0);"
                                (click)="filterClickEvent()">
                                <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.3104 1.67919L1.49018 17.4995" stroke="#4E4E4E" stroke-width="2" />
                                    <line x1="1.77569" y1="1.3107" x2="17.4143" y2="17.7099" stroke="#4E4E4E"
                                        stroke-width="2" />
                                </svg>
                            </a>
                            <h2>Filters</h2>

                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Organization</label>
                                <p-dropdown class="select-dropdown" [options]="companyBackup" optionLabel="CompanyName"
                                    [(ngModel)]="selectedCompany" [showClear]="true" placeholder="Select"></p-dropdown>
                            </div>
                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Interface</label>
                                <p-dropdown class="select-dropdown" [options]="interfaceList" optionLabel="label"
                                    optionValue="label" [(ngModel)]="selectedInterface" [showClear]="true"
                                    placeholder="Select"></p-dropdown>
                            </div>
                            <div class="select-menu filter-group">
                                <label class="filter-lbl">Status</label>
                                <p-dropdown class="select-dropdown" [options]="statusList" optionLabel="label"
                                    optionValue="label" [(ngModel)]="selectedStatus" [showClear]="true"
                                    placeholder="Select"></p-dropdown>
                            </div>

                            <div class="form-button-group">
                                <a class="btn-primary common-btn" (click)="onSearchChange('')">Apply</a>
                                <a [ngClass]="showClearFilter? '': 'active'" *ngIf="displayClearButton"
                                    class="btn-secondary" (click)="resetFilter()">Clear</a>
                                <!-- <a href="javascript:void(0);" class="clear-filter-btns" [ngClass]="showClearFilter? '': 'active'" (click)="resetFilter()">Clear Filters</a> -->
                            </div>

                        </div>
                    </div>
                </div>

                <div class="page-wrapper-listing" [ngClass]="!isCustomerAdmin ? '' : 'customer-admin'">
                    <div class="title-block">
                        <div class="title-block__left">
                            <h1>Customers</h1>
                            <p>Open a customer to set portal access and manage scanning subscriptions.</p>
                        </div>
                        <div class="responsive-filter">
                            <a class="btn-primary add-buttons" (click)="onAddIconClick(0)" href="javascript:void(0);">
                                <svg class="svg-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C7.34784 20 4.8043 18.9464 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C12.6522 0 15.1957 1.05357 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10ZM10.625 5.625C10.625 5.45924 10.5592 5.30027 10.4419 5.18306C10.3247 5.06585 10.1658 5 10 5C9.83424 5 9.67527 5.06585 9.55806 5.18306C9.44085 5.30027 9.375 5.45924 9.375 5.625V9.375H5.625C5.45924 9.375 5.30027 9.44085 5.18306 9.55806C5.06585 9.67527 5 9.83424 5 10C5 10.1658 5.06585 10.3247 5.18306 10.4419C5.30027 10.5592 5.45924 10.625 5.625 10.625H9.375V14.375C9.375 14.5408 9.44085 14.6997 9.55806 14.8169C9.67527 14.9342 9.83424 15 10 15C10.1658 15 10.3247 14.9342 10.4419 14.8169C10.5592 14.6997 10.625 14.5408 10.625 14.375V10.625H14.375C14.5408 10.625 14.6997 10.5592 14.8169 10.4419C14.9342 10.3247 15 10.1658 15 10C15 9.83424 14.9342 9.67527 14.8169 9.55806C14.6997 9.44085 14.5408 9.375 14.375 9.375H10.625V5.625Z"
                                        fill="white" />
                                </svg> Add Customer</a>

                            <a href="javascript:void(0);" class="mobile-block" (click)="filterClickEvent()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
                                    <path fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round"
                                        stroke-linejoin="round" stroke-width="2" d="M20 0H0l8 9.46V16l4 2V9.46z"
                                        transform="translate(1 1)" />
                                </svg>
                            </a>
                            <div class="search-box search-component">
                                <input type="text" #searchBox class="search-box__input" placeholder="Search"
                                    [(ngModel)]="searchText" (input)="onSearchChange($event.target.value)" />
                                <a href="javascript:void(0);" class="search-box__btns"><svg width="15" height="15"
                                        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6.41471 12.8287C7.83796 12.8284 9.22019 12.352 10.3413 11.4753L13.8662 15L15 13.8663L11.4751 10.3416C12.3523 9.22039 12.8291 7.83791 12.8294 6.41437C12.8294 2.87765 9.95162 0 6.41471 0C2.8778 0 0 2.87765 0 6.41437C0 9.95109 2.8778 12.8287 6.41471 12.8287ZM6.41471 1.60359C9.068 1.60359 11.2257 3.76123 11.2257 6.41437C11.2257 9.06751 9.068 11.2251 6.41471 11.2251C3.76143 11.2251 1.60368 9.06751 1.60368 6.41437C1.60368 3.76123 3.76143 1.60359 6.41471 1.60359Z"
                                            fill="#434343" />
                                    </svg>
                                </a>
                            </div>
                            <div class="customer-sum" *ngIf="companies?.length > 0">({{companies?.length}} Customers)
                            </div>
                        </div>
                    </div>
                    <div class="document-cabinet-list customers-list company-table">
                        <div class="table-responsive custom-scroll">
                            <p-table [value]="companies" class="tables customers-list-table"
                                (sortFunction)="customSort($event)" [customSort]="true">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th pSortableColumn="CompanyName">Org. & Contact<span
                                                class="sorting-icon"></span></th>
                                        <th pSortableColumn="ContactEmail">Contact Information<span
                                                class="sorting-icon"></span></th>
                                        <th pSortableColumn="InterfaceWith">Interface<span class="sorting-icon"></span>
                                        </th>
                                        <th pSortableColumn="AllowedDocumentStorage">Storage<span
                                                class="sorting-icon"></span></th>
                                        <!-- <th width="86" pSortableColumn="Status">Status<span class="sorting-icon"></span></th> -->

                                        <th pSortableColumn="PortalAccess">Doctainium Portal <span
                                                class="sorting-icon"></span></th>
                                        <th pSortableColumn="PortalAccess">Subscription Module <span
                                                class="sorting-icon"></span></th>
                                        <th pSortableColumn="SubscriptionCode">Active Subscription <span
                                                class="sorting-icon"></span></th>
                                        <th pSortableColumn="UsagePercent">Usage <span
                                                class="sorting-icon"></span></th>

                                        <th>Status</th>
                                        <th class="action-th-table text-center">Action</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-company>
                                    <tr>
                                        <td>
                                            <span class="org-name">{{company.CompanyName}}
                                                <span class="org-member"
                                                    pTooltip="{{company.ContactFirstName}} {{company.ContactLastName}}"
                                                    tooltipPosition="top">{{company.ContactFirstName}}
                                                    {{company.ContactLastName}}</span>
                                            </span>

                                        </td>
                                        <td>
                                            <span class="contact-info">
                                                <a class="email-link"
                                                    href="tel:{{company.ContactPhone}}">{{company.ContactPhone}}</a>
                                                <span class="org-member" pTooltip="{{company.ContactEmail}}"
                                                    tooltipPosition="top"><a class="email-link"
                                                        href="mailto:{{company.ContactEmail}}">{{company.ContactEmail}}</a></span>
                                            </span>
                                        </td>
                                        <td>{{company.InterfaceWith}}</td>
                                        <td *ngIf=" company.InterfaceWith === enumDatabaseType.enumInApp"><span
                                                class="storage">{{company.UsedStorage === '0.00 GB' ? '' :
                                                company.UsedStorage + ' / '}}{{company.AllowedDocumentStorage === null ?
                                                '0' : company.AllowedDocumentStorage}} GB</span></td>
                                        <td *ngIf=" company.InterfaceWith === enumDatabaseType.enumDocuware"> NA </td>

                                        <td>
                                            <span [ngClass]="(company.PortalAccess === 'Doctanium' || company.PortalAccess === 'Both') ? 'enabled' : 'disabled'">
                                                {{(company.PortalAccess === 'Doctanium' || company.PortalAccess === 'Both') ? 'Enabled' : 'Disabled'}}
                                            </span>
                                        </td>
                                        <td>
                                            <span [ngClass]="(company.PortalAccess === 'Subscription' || company.PortalAccess === 'Both') ? 'enabled' : 'disabled'">
                                                {{(company.PortalAccess === 'Subscription' || company.PortalAccess === 'Both') ? 'Enabled' : 'Disabled'}}
                                            </span>
                                        </td>
                                        <td>
                                            <ng-container *ngIf="company.SubscriptionCode; else noSub">
                                                {{company.SubscriptionCode}}
                                            </ng-container>
                                            <ng-template #noSub>-</ng-template>
                                        </td>
                                        <td>{{company.UsagePercent != null ? (company.UsagePercent | number:'1.0-2') + '%' : '-'}}</td>



                                        <td class="text-center">
                                            <span
                                                [ngClass]="company.IsActive ? 'status status__active' : 'status status__inactive' ">{{company.IsActive
                                                ? 'Active' : 'Inactive'}}</span>
                                            <!-- <span class="status status__inactive">Inactive</span> -->
                                        </td>

                                        <td class="action-td-table text-center">
                                            <a href="javascript:void(0);" (click)="tableMenu.toggle($event)">
                                                <svg data-dc-tpl="265" viewBox="0 0 24 24" width="18" height="18"
                                                    style="flex: 0 0 auto; fill: none; stroke: currentcolor; stroke-width: 2.6; stroke-linecap: round; stroke-linejoin: round;">
                                                    <circle data-dc-tpl="266" cx="12" cy="5" r="1"></circle>
                                                    <circle data-dc-tpl="267" cx="12" cy="12" r="1"></circle>
                                                    <circle data-dc-tpl="268" cx="12" cy="19" r="1"></circle>
                                                </svg>
                                            </a>


                                            <p-overlayPanel styleClass="table-menu-overlay" #tableMenu appendTo="body">
                                                <div class="table-action-menu">
                                                    <ul class="table-action-menu__list">
                                                        <li class="table-action-menu__item">
                                                            <a href="javascript:void(0);"
                                                                (click)="viewCompanyConfig(company)">View</a>
                                                        </li>
                                                        <li class="table-action-menu__item">
                                                            <a href="javascript:void(0);"
                                                                (click)="onAddIconClick(company.CompanyId)">Edit</a>
                                                        </li>
                                                        <li class="table-action-menu__item">
                                                            <a href="javascript:void(0);"
                                                                (click)="ResendPasswordLinkPopup(company)">Reset
                                                                Password</a>
                                                        </li>
                                                        <!-- <li class="table-action-menu__item">
                                                            <a href="javascript:void(0);"
                                                                routerLink="/company/subscription">Subscription</a>
                                                        </li> -->
                                                        <li class="table-action-menu__item">
                                                            <a href="javascript:void(0);"
                                                                (click)="openDocumentDeletePopup(company)">Delete</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </p-overlayPanel>


                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage" let-company>
                                    <tr>
                                        <td [attr.colspan]="10" class="text-center">
                                            No records found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <div class="loader-outer" *ngIf="loading">
                        <div class="loader"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="common-popup add-update-popup">
    <div class="modal-overlay">
      <div class="modal-box">
        <div class="modal-body">
            <app-company-manage (isCompanyListUpdated)="companyListUpdated($event)" [companyId]="selectedCompanyId" [count]="companyCount"></app-company-manage>
        </div>
      </div>
    </div>
</div> -->

<p-dialog styleClass="popop" [(visible)]="ManageCompany" [modal]="true" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="popop-content width-800 scroll-bar">
        <!-- <app-user-manage [refresh]="refreshForm" [id]="selectedUserId" [companyId]="selectedCompanyId" (close)="ClosePopup($event)"></app-user-manage> -->
        <app-company-manage (close)="ClosePopup($event)" (isCompanyListUpdated)="companyListUpdated($event)"
            [companyId]="selectedCompanyId" [count]="companyCount"></app-company-manage>
    </div>
</p-dialog>

<p-dialog styleClass="popop" [(visible)]="DeletePopup" [modal]="true" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">

    <div class="popop-content delete-popop-content">
        <h3>Delete Customer</h3>
        <p>Are you sure you want to delete {{deleteCompany?.CompanyName}}?</p>
        <div class="button-block">
            <button class="btn-secondary" type="button" (click)="closeDeletePopup()">No</button>
            <button class="btn-primary" type="submit" (click)="onDeleteCompany()">Yes</button>
        </div>
        <div class="loader-outer" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>
</p-dialog>

<!-- Reset Password Pop up -->
<p-dialog styleClass="popop" [(visible)]="ResendLink" [modal]="true" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false">
    <div class="popop-content delete-popop-content">
        <h3>Reset Password</h3>
        <p>Do you want to send Reset Password link to {{selectedCompanyUser.ContactEmail}} ?</p>
        <div class="button-block">

            <button class="btn-secondary" type="button" (click)="cancelSendingLink()">No</button>
            <button class="btn-primary" type="submit" (click)="sendLink()">Yes</button>
        </div>
        <div class="loader-outer" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>
</p-dialog>
<!-- Reset Password Pop up -->